import Raritychart from "./assets/rarity-chart.png";
import { Image } from '@chakra-ui/react';

const Rarities = ({ accounts, setAccounts }) => {
return (
    <div>
    <Image boxSize='75%' borderRadius='20px' margin='auto' src={Raritychart} />
    </div>
);
};

export default Rarities;